export const List_const = {
  list_not_require_id_app_default: [
    "user",
    "users",
    "notification",
    "message",
    "listinfo",
    "moduleinfo",
    "reportinfo",
    "tableinfo",
    "labelinfo",
    "rptobject",
    "trangthai",
    "sysgroup",
    "sysconfig",
    "schedule",
    "templatestore",
    "tinhthanh",
    "quanhuyen",
    "xaphuong",
    "token",
    "importexceltemplate",
    "exportexceltemplate",
  ],
};
export const envConfig = {
  SERVER_URL_REPORT: process.env.server_url_report,
  SERVER_URL: process.env.server_url,
  GOOGLE_RECAPTCHA_SITE_KEY: process.env.GOOGLE_RECAPTCHA_SITE_KEY,
  ID_APP: process.env.id_app,
  GROUP_ID: process.env.group_id,
  TRUST_KEY: process.env.trustkey,
  SYSTEM_CODE: process.env.system_code,
  PUBLIC_TOKEN: process.env.public_token,
  APP_CODE: process.env.app_code,
  AGAIN_LINK: process.env.again_link,
};
